import { IStoreState } from "Interfaces";

const empty = { hasLoaded: false, list: [] };

export const projectListSelector = (clientId: string) => (state: IStoreState) =>
  clientId ? state.application.projects[clientId] || empty : empty;
